module.exports = __webpack_public_path__ + "media/images/portugal_center/ferreiradozezere-562db110fb2d77e218b7620ad05a433b.jpeg";